<template>
<div class="container text-center">
    <img :src="fields.logo" class="logo" v-if="fields.logo" />
</div>
</template>

<script>
export default {
  name: 'header-component',
  data () {
    return {
      fields: {
        title: null,
        logo: null
      }
    }
  },
  methods: {
    fetchPrismicContent () {
      this.$prismic.client.getSingle('component-header')
        .then((document) => {
          this.fields.logo = document.data.logo.url
          this.fields.title = document.data.title
        })
    }
  },
  created () {
    this.fetchPrismicContent()
  }
}
</script>

<style scoped>
  .container {
      margin-bottom: 20%;
  }

  .logo {
      width: 250px;
      margin-top: -120px;
  }
</style>
